"use strict";

import angular from "angular";

import template from "./comparation-value.component.html";
import "./themes/comparation-value.component-dark.scss";
import "./themes/comparation-value.component.scss";

import { ColorService } from "../../../presentation/services/ColorService/ColorService";

import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";
import * as DateUtils from "../../../utils/date/date";

class ComparationValueComponent {
    constructor($rootScope, $scope, $filter, $element, ThemesService) {
        this.$scope = $scope;

        this.FormatUnits = new FormatUnits($filter);

        this.ThemesService = ThemesService;

        this.$rootScope = $rootScope;
        this.$element = $element;

        this.caret = "fa fa-minus";
        this.formattedValue = "";
        this.tooltip = "";

        const deregisterThemesService = this.$rootScope.$on(
            "THEMES_SERVICE_THEME_CHANGED",
            (event, theme) => {
                this._setColorOfValues();
            }
        );

        this.$scope.$on("$destroy", () => {
            deregisterThemesService();
        });
    }

    $onInit() {
        this._setValue();
        this._setTooltip();
        this._setColorOfValues();
    }

    $onChanges(changes) {
        this._setValue();
        this._setTooltip();
        this._setColorOfValues();
    }

    _setColorOfValues() {
        const colorPath = this.polarityColor.replace("-", ".");

        const colorRgba = new ColorService({
            ThemesService: this.ThemesService
        }).colorByPath(colorPath);

        this.$element.find("span").css("color", colorRgba);
        this.$element.find("i").css("color", colorRgba);
    }

    /**
     * @private
     * Setta o value
     */
    _setValue() {
        if (this.variationCondition) this.caret = "fa fa-caret-up";
        else this.caret = "fa fa-caret-down";
        if (this.value === 0) this.caret = "fa fa-minus";

        this.formattedValue = this.FormatUnits.formatValue(
            this.unit,
            Math.abs(this.value),
            1,
            true
        );
    }

    /**
     * @public
     * Indeitica se o number e plural ou singular
     * @param {Number} number Number
     * @returns {Boolean}
     */
    isPlural(number) {
        return number >= 2 || number < 0;
    }

    /**
     * @private
     * Retorna a label da unidade
     */
    _getUnitLabel(unit) {
        const units = {
            day: () => {
                return this.isPlural(this.tooltipValue) ? " dias" : " dia";
            }
        };

        if (units[unit]) return units[unit]();
        return "";
    }

    /**
     * @private
     * Setta o tooltip
     */
    _setTooltip() {
        if (!this.tooltipUnit) return (this.tooltip = "");

        const word = this.variationCondition ? "Aumento" : "Queda";

        const valueFormatted = this.FormatUnits.formatValue(
            this.tooltipUnit,
            Math.abs(this.tooltipValue)
        );

        const comparationDateLabel = DateUtils.getComparationLabel(
            this.currentPeriod,
            this.currentComparation
        );

        const phraseVariation = this.tooltipValue
            ? `${word} de ${valueFormatted}${this._getUnitLabel(
                  this.tooltipUnit
              )}`
            : `Não houve variação`;

        this.tooltip = `${phraseVariation} comparado com ${comparationDateLabel}`;
    }
}

export { ComparationValueComponent };

ComparationValueComponent.$inject = [
    "$rootScope",
    "$scope",
    "$filter",
    "$element",
    "ThemesService"
];

const name = "comparationValueComponent";
const def = {
    bindings: {
        value: "<",
        polarityColor: "<",
        unit: "@",
        variationCondition: "<",
        tooltipValue: "<",
        tooltipUnit: "<",
        currentPeriod: "<",
        currentComparation: "<"
    },
    controller: ComparationValueComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
